import Vue from 'vue'
import CategorySearch from '@/components/CategorySearch.vue'

if (document.querySelector("#app-categories") !== null) {
  new Vue({
    components: {
      CategorySearch
    }
  }).$mount('#app-categories')
}
